/** Sentinel the team switcher uses for system-wide admin scope. */
export const GLOBAL_ORGANIZATION_ID = 'GLOBAL'

export function isGlobalOrganizationId(id: string | null | undefined): boolean {
  return (id ?? '').trim().toUpperCase() === GLOBAL_ORGANIZATION_ID
}

/**
 * Prefer a real tenant org over Global Scope.
 * Order: active_org_id from /v1/me → valid stored selection → first membership.
 */
export function resolvePreferredOrganizationId(opts: {
  activeOrgId?: string | null
  memberships?: { organizationId: string }[] | null
  storedId?: string | null
}): string | null {
  const clean = (value?: string | null): string | null => {
    const trimmed = (value ?? '').trim()
    if (!trimmed || isGlobalOrganizationId(trimmed)) return null
    return trimmed
  }

  const fromMe = clean(opts.activeOrgId)
  if (fromMe) return fromMe

  const membershipIds = (opts.memberships ?? [])
    .map((m) => clean(m.organizationId))
    .filter((id): id is string => Boolean(id))

  const stored = clean(opts.storedId)
  if (stored && (membershipIds.length === 0 || membershipIds.includes(stored))) {
    return stored
  }

  return membershipIds[0] ?? null
}
